<div [innerHTML]="params.value"></div>